
import { Component, Vue } from 'vue-property-decorator';
import Env from '@/services/env.service';

@Component({
  components: {
  },
})
export default class Info extends Vue {
  get environment() {
    return Env.get('VUE_APP_ENVIRONMENT');
  }

  public start() {
    this.$router.push('/calculator');
  }
}
